import { Box } from '@/components/ui/box';
import { Button } from '@/components/ui/button';
import { FlexCol, FlexRow } from '@/components/ui/flex';
import { Text } from '@/components/ui/text';
import { paths } from '@/paths';
import { useChatNavigate } from '@/utils/aiUtils';
import { Brain } from 'lucide-react';
import { useState, type FC } from 'react';
import { useNavigate } from 'react-router';
import { Input } from './components/Input';

export const AskPage: FC = () => {
  const { navigateToChat } = useChatNavigate();

  const [prompt, setPrompt] = useState('');

  const navigate = useNavigate();

  const handleSubmit = async (promptText: string) => {
    await navigateToChat({ initialMessage: { text: promptText } });
  };

  const handleSeeAllSources = () => {
    navigate(`${paths.sources}`);
  };

  return (
    <FlexCol
      h="full"
      w="full"
      alignItems="center"
      justifyContent="center"
      mx="auto"
      className="gap-[60px] max-w-[1148px] px-24"
    >
      <FlexCol w="full" alignItems="center" justifyContent="center" gap="8">
        <Text variant="hero6">How can I help you today?</Text>
        <FlexCol w="full" alignItems="center" justifyContent="center">
          <FlexRow
            w="full"
            alignItems="center"
            justifyContent="between"
            gap="2"
            px="4"
            pt="3"
            pb="7"
            br="lg"
            className="bg-neutral-50"
          >
            <FlexRow alignItems="center" gap="2">
              <Brain className="w-4 h-4" />
              <Text variant="body" color="primary">
                Instant answers from FDA 21 CFR, EU MDR, MDCG guidance, MEDDEV,
                and 800+ regulatory sources.
              </Text>
            </FlexRow>
            <Button
              variant="secondary"
              size="sm"
              onClick={handleSeeAllSources}
              className="w-fit h-[24px]"
            >
              See all sources
            </Button>
          </FlexRow>
          <FlexCol w="full" className="-translate-y-4">
            <Input
              onSubmit={handleSubmit}
              currentPrompt={prompt}
              setCurrentPrompt={setPrompt}
            />
            <FlexRow
              w="full"
              className="border-b border-neutral-300 rounded-b-lg"
            >
              <Box
                w="1/3"
                h="1"
                className="bg-yellow-400 -mr-[10px] mix-blend-multiply rounded-bl-lg"
              />
              <Box
                w="1/3"
                h="1"
                className="bg-green-300 -mr-[10px] mix-blend-multiply"
              />
              <Box
                w="1/3"
                h="1"
                className="bg-blue-500 -mr-[10px] mix-blend-multiply"
              />
              <Box
                w="1/3"
                h="1"
                className="bg-magenta-500 -mr-[10px] mix-blend-multiply"
              />
              <Box
                w="1/3"
                h="1"
                className="bg-yellow-400 mix-blend-multiply rounded-br-lg"
              />
            </FlexRow>
          </FlexCol>
        </FlexCol>
      </FlexCol>
    </FlexCol>
  );
};
